import { DcmaTable } from '../components/DcmaTable.jsx';

/**
 * DCMA 14-Point panel — thin wrapper around DcmaTable that pulls from
 * analysis.dcma.points. No data shaping or filtering happens here; the
 * table is fed exactly what the engine emitted.
 */
export function DcmaPanel({ analysis }) {
  const points = analysis?.dcma?.points;
  if (!Array.isArray(points) || points.length === 0) {
    return (
      <div className="shell-state">
        <h1 className="shell-state-title">DCMA 14-Point</h1>
        <p>No DCMA results available for this report.</p>
      </div>
    );
  }
  return <DcmaTable points={points} />;
}
